/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

// Remove our own shallowPropsEqual implementation (which was narrower in scope as it threw if arg was not {})
// in favor of react's shallowEqual implementation below

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 *
 * This function is consistent with the React Memo's default 'arePropsEqual' implementation (AFAIK).
 */
export function shallowEqual(objA, objB) {
  // Stolen from: https://github.com/facebook/react/blob/v17.0.2/packages/shared/shallowEqual.js
  // so as to be consistent with the default Memo 'arePropsEqual' implementation.

  // Note that arg type of Record<string, any> is as close as I could get to 'plain object' type that
  // supports keys, which is a bit narrower than 'Object'.
  // React shallowEqual definition uses Flow's 'mixed' type, which is supertype of all types (equivalent to 'any'?).

  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (let i = 0; i < keysA.length; i++) {
    if (!objB.hasOwnProperty(keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
//# sourceMappingURL=RouterUtils.js.map
